export const PROBABILITIES = [
  {
    sum: 5,
    probabilities: 0.000128601,
  },
  {
    sum: 6,
    probabilities: 0.000643004,
  },
  {
    sum: 7,
    probabilities: 0.001929012,
  },
  {
    sum: 8,
    probabilities: 0.004501029,
  },
  {
    sum: 9,
    probabilities: 0.009002058,
  },
  {
    sum: 10,
    probabilities: 0.016203704,
  },
  {
    sum: 11,
    probabilities: 0.026363169,
  },
  {
    sum: 12,
    probabilities: 0.039223251,
  },
  {
    sum: 13,
    probabilities: 0.054012346,
  },
  {
    sum: 14,
    probabilities: 0.069444444,
  },
  {
    sum: 15,
    probabilities: 0.083719136,
  },
  {
    sum: 16,
    probabilities: 0.094521605,
  },
  {
    sum: 17,
    probabilities: 0.100308642,
  },
  {
    sum: 18,
    probabilities: 0.100308642,
  },
  {
    sum: 19,
    probabilities: 0.094521605,
  },
  {
    sum: 20,
    probabilities: 0.083719136,
  },
  {
    sum: 21,
    probabilities: 0.069444444,
  },
  {
    sum: 22,
    probabilities: 0.054012346,
  },
  {
    sum: 23,
    probabilities: 0.039223251,
  },
  {
    sum: 24,
    probabilities: 0.026363169,
  },
  {
    sum: 25,
    probabilities: 0.016203704,
  },
  {
    sum: 26,
    probabilities: 0.009002058,
  },
  {
    sum: 27,
    probabilities: 0.004501029,
  },
  {
    sum: 28,
    probabilities: 0.001929012,
  },
  {
    sum: 29,
    probabilities: 0.000643004,
  },
  {
    sum: 30,
    probabilities: 0.000128601,
  },
];
